import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function ThankYouSuccessModal({ show, onHide, onRedirect }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="success-modal"
            className='success-modal'
            centered
        >
            <Modal.Header>
                <Modal.Title id="success-modal">
                    Your inspection request has been successfully submitted.
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='text mb-4'>Email confirmation will be sent to you shortly.</div>
                <div className='text mb-4'>
                    You will be contacted if any additional information is needed or when your inspection result is available.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button id='backToHome' className='backToHome text-uppercase' onClick={onRedirect}>Go Back to homepage</Button>
            </Modal.Footer>
        </Modal>
    );
}


export default ThankYouSuccessModal;